var map = {
	"./big-arrow-left.svg": 140,
	"./big-arrow-right.svg": 141,
	"./big-close.svg": 142,
	"./big-download.svg": 143,
	"./big-lock.svg": 144,
	"./big-marker.svg": 145,
	"./big-minus.svg": 146,
	"./big-plus.svg": 147,
	"./big-search.svg": 148,
	"./big-speech.svg": 149,
	"./big-vita.svg": 150,
	"./filled-list.svg": 151,
	"./gallery.svg": 152,
	"./small-arrow-down.svg": 153,
	"./small-arrow-top-right.svg": 154,
	"./small-burger.svg": 155,
	"./small-close.svg": 156,
	"./small-down.svg": 157,
	"./small-info.svg": 158,
	"./small-left.svg": 159,
	"./small-lock.svg": 160,
	"./small-right.svg": 161,
	"./small-star-filled.svg": 162,
	"./small-star-outline.svg": 163,
	"./small-user.svg": 164,
	"./social-small-facebook.svg": 165,
	"./social-small-instagram.svg": 166,
	"./social-small-linkedin.svg": 167,
	"./social-small-tikTok.svg": 168,
	"./social-small-twitter.svg": 169,
	"./social-small-xing.svg": 170,
	"./social-small-youtube.svg": 171,
	"./thumbnails.svg": 172,
	"./wappen.svg": 173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;